import { Component, OnInit } from '@angular/core';
import { Router, NavigationEnd } from '@angular/router';
import { filter } from 'rxjs/operators';
import { AuthService } from 'src/app/core/helpers/auth.service';
import { LegalModalsService } from '../services/legal-modals.service';
//import { fadeInOut, slideInOut, rotate } from 'src/assets/animations';
import { fadeInOut} from 'src/assets/animations';

@Component({
  selector: 'loyaltic-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss'],
  animations: [fadeInOut]
})
export class HeaderComponent implements OnInit {
  menuOpen = false;
  isLoggedIn = false;
  constructor(
    private router: Router,
    private authService: AuthService,
    private legalModalsService: LegalModalsService
  ) {
    // Listen to the router events and close the menu on navigation end
    this.router.events.pipe(
      filter(event => event instanceof NavigationEnd)
    ).subscribe(() => {
      if (this.menuOpen) {
        this.closeMenu();
      }
    });
  }
  toggleMenu(): void {
    this.menuOpen = !this.menuOpen;
  }

  closeMenu(): void {
    this.menuOpen = false;
  }

  openRulesModal(): void {
    this.legalModalsService.openRules();
    this.closeMenu();
  }

  openPolicyModal(): void {
    this.legalModalsService.openPolicy();
    this.closeMenu();
  }
  ngOnInit(): void {
    this.isLoggedIn = this.authService.getUserId() !== null;

    this.authService.getAuthentication().subscribe((response:any) => {
      this.isLoggedIn = response.isAuthenticated;
    })
    
  }
  logout(): void {
    this.authService.updateAuthentication(false);
    this.clearLocalSession();
    this.toggleMenu();
    this.router.navigate(['/']);
  }

  goToHome(): void {
    localStorage.removeItem('tournamentId');
    this.router.navigate(['/']);
  }

  clearLocalSession(): void {
    localStorage.clear();
    this.router.navigateByUrl('/');
  }

}
